import CarouselIndicator from '@/components/molecules/CarouselIndicador';
import PlanoAssinatura from '@/components/molecules/PlanoAssinatura';
import { theme } from '@/styles/theme';
import { PlanoProduto } from '@/types/produto';
import * as S from './styles';
import IconButton from '@/components/atoms/IconButton';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import useBreakpoint from '@/hooks/useBreakpoint';
import { usePaginacaoScrollHorizontal } from '@/hooks/usePaginacaoScrollHorizontal';
import { Ref } from 'react';
import ScrollAreaContainer from '@/components/molecules/ScrollAreaContainer';

interface ListagemPlanosAssinaturaProps {
  $planosAssinaturas: PlanoProduto[];
  $planoSelecionado: number;
  $cliquePlano: (index: number) => void;
}

export default function ListagemPlanosAssinatura(
  props: ListagemPlanosAssinaturaProps,
) {
  const { $planosAssinaturas, $planoSelecionado, $cliquePlano } = props;

  const { breakpoint } = useBreakpoint();

  const {
    viewportRef,
    scrollContainerRef,
    itemRef,
    paginaAtual,
    totalPaginas,
    lidarComScroll,
    irParaPaginaAnterior,
    irParaProximaPagina,
    irParaPagina,
  } = usePaginacaoScrollHorizontal({
    gap: theme.spacing[4],
    totalItens: $planosAssinaturas.length,
  });

  return (
    <S.Container>
      <S.ContainerScroll ref={viewportRef}>
        {paginaAtual > 1 && paginaAtual <= totalPaginas ? (
          <S.ContainerButtonArrow $position="esquerda">
            <IconButton
              $size={2}
              $state="default"
              $variant="solid"
              $color="accent"
              $highContrast={false}
              $loading={false}
              $Icon={IconeSeta}
              $iconProps={{ direcao: 'esquerda' }}
              $focusRing={false}
              aria-label="Botao Ver Foto Anterior"
              $onClick={irParaPaginaAnterior}
              $mostrarEstilizacaoHover={false}
              style={{
                borderRadius: '50%',
              }}
            />
          </S.ContainerButtonArrow>
        ) : null}
        <ScrollAreaContainer
          refScrollAreaViewport={scrollContainerRef}
          orientacao="horizontal"
          lidarScroll={lidarComScroll}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'stretch',
              gap: theme.spacing[4],
            }}
          >
            {$planosAssinaturas.map((plano, index) => (
              <button
                key={index}
                ref={
                  index === 0 ? (itemRef as Ref<HTMLButtonElement>) : undefined
                }
                style={{
                  background: 'none',
                  outline: 'none',
                }}
                onClick={() => $cliquePlano(index)}
              >
                <PlanoAssinatura
                  $plano={plano}
                  $planoEstaSelecionado={$planoSelecionado === index}
                  $breakpoint={breakpoint}
                  $expansivel={totalPaginas === 1}
                />
              </button>
            ))}
          </div>
        </ScrollAreaContainer>
        {paginaAtual < totalPaginas ? (
          <S.ContainerButtonArrow $position="direita">
            <IconButton
              $size={2}
              $state="default"
              $variant="solid"
              $color="accent"
              $highContrast={false}
              $loading={false}
              $Icon={IconeSeta}
              $iconProps={{ direcao: 'direita' }}
              $focusRing={false}
              aria-label="Botao Ver Foto Anterior"
              $onClick={irParaProximaPagina}
              $mostrarEstilizacaoHover={false}
              style={{
                borderRadius: '50%',
              }}
            />
          </S.ContainerButtonArrow>
        ) : null}
      </S.ContainerScroll>
      {totalPaginas > 1 ? (
        <CarouselIndicator
          $currentSlide={paginaAtual}
          $totalImagens={totalPaginas}
          $onClickIndicator={(page) => irParaPagina(page)}
          $indexValorAjuda={1}
        />
      ) : null}
    </S.Container>
  );
}
